import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";




class DeleteModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }



    render() {
        return (
            <Modal
                {...this.props}
                size="sm"    aria-labelledby="example-modal-sizes-title-lg">
              
                <Modal.Body className="p-4">
                    <Row>
                        <Col sm={12}>
                            <Col sm={12} className="text-center mt-2">

                                {
                                    this.props.currentStep == "1" ? (

                                        <div class="spinner-border text-primary"></div>
                                    ) :
                                        (
                                            ""
                                        )

                                }
                            </Col>
                            <Col sm={12} class="text-center">
                                {/* <h6 className="text-center mb-4">Are You Sure You Want to Delete</h6> */}
                                {/* <div className="d-flex flex-row justify-content-center">
                                    <Button className="btn btn-success text-uppercase px-lg-5 ml-1" onClick={this.props.handleDelete}>Yes</Button>
                                    <Button className="btn btn-danger text-uppercase px-lg-5 ml-1" onClick={this.props.onHide}>No</Button>
                                </div> */}
                                <p className="text-center text-danger mt-2">{this.props.stateData.submitError}</p>
                            <p className="text-center text-danger mt-2">{this.props.stateData.currentStep == 5 ? "Delete Data Sucessfully" : ""}</p>
                        </Col>
                        </Col>
                    </Row>


                </Modal.Body>
            </Modal>
        )
    }
}

export default DeleteModal;